import { useEffect } from "react";

import useSettings from "../../data/useSettings";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import AdminSettingsTable from "../../components/adminSettings/AdminSettingsTable";
import LoadingWheel from "../../components/shared/LoadingWheel";

// Site details DEFRA needs on every Receipt of Waste. Same DEFRA:* settings as Admin Settings,
// filtered into one place - mirrors CodSettings for the COD: keys.
export default function WasteTrackingSettings() {
  const { setInfo } = usePageNameContext();
  const { generalSettings, loading } = useSettings();

  useEffect(() => {
    setInfo({
      name: "Waste Tracking",
      desc: "DEFRA receiver details used on every waste movement",
    });
  }, []);

  const defraSettings = (generalSettings ?? []).filter((s) => s.key.startsWith("DEFRA:"));

  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900">DEFRA Site Details</h2>
        <p className="mt-1 text-sm text-gray-500">
          Sent as the receiver on every movement. All of <span className="font-mono">ApiCode</span>,{" "}
          <span className="font-mono">SiteName</span>, <span className="font-mono">AuthorisationNumber</span> (permit),{" "}
          <span className="font-mono">SiteAddress</span> and <span className="font-mono">SitePostcode</span> must be filled in
          before anything can be submitted. <span className="font-mono">CarrierRegistrationNumber</span> is your own carrier
          registration for vehicles your drivers collect; <span className="font-mono">HazardCodes</span> (comma separated HP codes)
          and <span className="font-mono">RecoveryCode</span> are optional overrides; <span className="font-mono">TrackFrom</span>{" "}
          hides vehicles collected before that date from the pending list.
        </p>

        {loading ? (
          <div className="mt-4">
            <LoadingWheel />
          </div>
        ) : defraSettings.length ? (
          <AdminSettingsTable settings={defraSettings} />
        ) : (
          <p className="mt-4 text-sm text-gray-500">No DEFRA settings found for this customer yet - please contact support to have them set up.</p>
        )}
      </section>
    </div>
  );
}
